import { createSlice } from '@reduxjs/toolkit'

export const uiToggles = createSlice({
  name: 'uiToggles',
  initialState: {
    loadingOverlay: false,
    currentMobileFilter: null,
  },
  reducers: {
    toggleLoadingOverlay: (state, action) => {
      state.loadingOverlay = action.payload
    },
    setCurrentMobileFilter: (state, action) => {
      state.currentMobileFilter = action.payload
    },
  },
})

export const { toggleLoadingOverlay, setCurrentMobileFilter } = uiToggles.actions
